export default __webpack_public_path__ + "static/media/netpay-logo-small.de62225b.png";